import { render, staticRenderFns } from "./Crp.vue?vue&type=template&id=53366582&scoped=true&"
import script from "./Crp.vue?vue&type=script&lang=js&"
export * from "./Crp.vue?vue&type=script&lang=js&"
import style0 from "./Crp.vue?vue&type=style&index=0&id=53366582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53366582",
  null
  
)

export default component.exports